import _ from 'lodash'
import SEMICONDUCTORS_NAV_CONFIG from './config'
import axios from 'axios'

class SemiconductorsNavClass {
    constructor() {
        this.DOM = {
            section: SEMICONDUCTORS_NAV_CONFIG.section,
            lines: SEMICONDUCTORS_NAV_CONFIG.lines,
            types: SEMICONDUCTORS_NAV_CONFIG.types,
            formats: SEMICONDUCTORS_NAV_CONFIG.formats
        }

        this.json = null
        this.DOM.section ? this.init() : null
    }

    init() {
        this._getJSON()
    }

    _getJSON() {
        axios.get( this.DOM.section.getAttribute( 'data-json-url' ) )
        .then( ( response ) => {
            this.json = response.data
            this._countLines()
            this._countTypes()
            this._countFormats()
        })
        .catch( ( error ) => {
        })
    }

    _countLines() {
        this.DOM.lines.forEach( ( item ) => {
            let line = item.getAttribute( 'data-line' ),
                html = item.innerHTML
            
            const result = this.json.filter( element => element[ 'Product line' ] == line ).length
            item.innerHTML = `${html} (${result})`
        })
    }

    _countTypes() {
        this.DOM.types.forEach( ( item ) => {
            let line = item.getAttribute( 'data-line' ),
                type = item.getAttribute( 'data-type' ),
                html = item.innerHTML
            
            const result = this.json.filter( element => element[ 'Product line' ] == line && element[ 'Type' ] == type ).length
            item.innerHTML = `${html} (${result})`
        })
    }

    _countFormats() {
        this.DOM.formats.forEach( ( item ) => {
            let group = item.getAttribute( 'data-group' ),
                format = item.getAttribute( 'data-format' ),
                html = item.innerHTML
            
            const result = this.json.filter( element => element[ 'Outline' ] == format ).length
            item.innerHTML = `${html} (${result})`
        })
    }


}

const SEMICONDUCTORS_NAV = new SemiconductorsNavClass()
export default SEMICONDUCTORS_NAV